<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Formularios</h4>
            <div class="small text-muted">Administración de todos los formularios para interfaces web</div>
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col lg="9">
          <b-row>            
            <b-col lg="4">
              <Widget :configWidget="configWidget" reference="cant_forms" :hasAccess="configWidget.elements.cantForms" />
            </b-col>
            <b-col lg="4">
              <Widget :configWidget="configWidget" reference="cant_queryToday" :hasAccess="configWidget.elements.cantQueryToday" />
            </b-col>
            <b-col lg="6">
              <Widget :configWidget="configWidget" reference="bar_forms_query_months" :hasAccess="configWidget.elements.barFormsQueryMonths" />
            </b-col>
            <b-col lg="6">
              <Widget :configWidget="configWidget" reference="list_last_querys" :hasAccess="configWidget.elements.listLastQuerys" />
            </b-col>
          </b-row>
        </b-col>  
        <b-col lg="3" md="12" sm="12">        
          <b-list-group class="mb-1" v-if="configSubView.elements.forms">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openForms()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Formularios</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de formularios
              </p>
            </b-list-group-item>
          </b-list-group>   

          <b-list-group class="mb-1" v-if="configSubView.elements.details">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openQueries()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Consultas</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Vista de las consulta recibidas filtradas por formularios
              </p>
            </b-list-group-item>
          </b-list-group>      

          <hr v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
          <b-list-group class="mt-2" v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
            <b-list-group-item v-for="item in arr.PHPCustom" :key="item.id" href="#" class="flex-column align-items-start" @click="openPHPCustom(item)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{item.name}}</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                {{item.observations}}
              </p>
            </b-list-group-item>
          </b-list-group>                                           
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import ServicesPHP from '@/components/modules/users/php/staff/services'

  export default {
    components: {
      Widget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.FORMULARIOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.FORMULARIOS,
          profile_id: Profiles.PERSONAL,
          elements: {             
            cantForms: true,
            cantQueryToday: true,
            barFormsQueryMonths: true,    
            listLastQuerys: true,          
          }
        },
        configSubView: {
          module_id: Modules.FORMULARIOS,
          profile_id: Profiles.PERSONAL,
          elements: {
            forms: true,
            details: true,
            php_custom: true,
          }
        },           
        primaryColor: '',
        arr: {
          PHPCustom: []
        }        
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      /* Configurar permisos de los widgets */      
      this.configWidget.elements.cantForms = Helper.hasAccessWidget(this.configWidget, 'cant_forms')
      this.configWidget.elements.cantQueryToday = Helper.hasAccessWidget(this.configWidget, 'cant_queryToday')
      this.configWidget.elements.barFormsQueryMonths = Helper.hasAccessWidget(this.configWidget, 'bar_forms_query_months')
      this.configWidget.elements.listLastQuerys = Helper.hasAccessWidget(this.configWidget, 'list_last_querys')
      /* Fin configuracion */

      /* Configurar permisos de las sub vistas */
      this.configSubView.elements.forms = Helper.showAccessView(this.configSubView, 'crudForms')      
      this.configSubView.elements.details = Helper.showAccessView(this.configSubView, 'detailForms')      
      this.configSubView.elements.php_custom = Helper.showAccessPHPCustom()
      /* Fin configuracion */        
    },
    mounted() {
      this.setup()
      this.getPHPCustom()
    }, 
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 
      
      openForms() {
        this.$router.push({ name: 'FormsStaffCrudForms' })
      },    
      openQueries() {
        this.$router.push({ name: 'FormsStaffDetailForms' })
      },         

      getPHPCustom() {
        ServicesPHP.obtenerPHPByModule(Modules.FORMULARIOS)
        .then((response) => {
          this.arr.PHPCustom = response.data       
        })
      },
      openPHPCustom(item) {
        this.$router.push({ name: 'ViewStaffViewPHPCustom', params: {id: item.id} })
      }      
    }    
   
  }
</script>

<style>

</style>
